<button *ngIf="canShowAnonymSubscription()" (click)="addAnonym()"
            mat-stroked-button color="primary" >+ Gastbuchung</button>
